export default __webpack_public_path__ + "static/media/invoice.e37027bf.svg";